var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v("Test")]),_c('div',{staticClass:"ui message"},[_c('div',{staticClass:"header"},[_vm._v("JCSteele Test")])])])
}]

export { render, staticRenderFns }